import React from 'react';

import privacyPolicyContent from './privacyPolicyContent';

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-xl font-semibold text-slate-900">{title}</h2>
    <div className="space-y-3 text-slate-700">{children}</div>
  </section>
);

const Subsection = ({ title, children }) => (
  <section className="space-y-2 pl-0 sm:pl-2">
    <h3 className="text-base font-semibold text-slate-900">{title}</h3>
    <div className="space-y-2 text-slate-700">{children}</div>
  </section>
);

const BulletedList = ({ items }) => (
  <ul className="list-disc pl-6 space-y-1">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);

const NumberedList = ({ items }) => (
  <ol className="list-decimal pl-6 space-y-1">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ol>
);

const renderBlock = (block) => (
  <>
    {(block.paragraphs || []).map((text) => (
      <p key={text}>{text}</p>
    ))}
    {Array.isArray(block.bullets) && block.bullets.length > 0 && (
      <BulletedList items={block.bullets} />
    )}
    {Array.isArray(block.numbered) && block.numbered.length > 0 && (
      <NumberedList items={block.numbered} />
    )}
    {(block.tail || []).map((text) => (
      <p key={text}>{text}</p>
    ))}
    {Array.isArray(block.tailBullets) && block.tailBullets.length > 0 && (
      <BulletedList items={block.tailBullets} />
    )}
    {(block.closing || []).map((text) => (
      <p key={text}>{text}</p>
    ))}
  </>
);

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-100 py-6 sm:py-10">
      <main className="max-w-4xl mx-auto bg-white border border-slate-200 rounded-lg shadow-sm p-5 sm:p-8 space-y-6">
        <header className="space-y-2">
          <h1 className="text-3xl font-bold text-slate-900">{privacyPolicyContent.title}</h1>
          <p className="text-slate-600">Last updated: {privacyPolicyContent.lastUpdated}</p>
          {privacyPolicyContent.intro.map((text) => (
            <p className="text-slate-700" key={text}>{text}</p>
          ))}
        </header>

        {privacyPolicyContent.sections.map((section) => (
          <Section key={section.title} title={section.title}>
            {renderBlock(section)}
            {(section.subsections || []).map((subsection) => (
              <Subsection key={subsection.title} title={subsection.title}>
                {renderBlock(subsection)}
              </Subsection>
            ))}
          </Section>
        ))}
      </main>
    </div>
  );
};

export default PrivacyPolicyPage;
